// Row.tsx
import React from 'react';
import Cell from './Cell';
import './App.css';

interface RowProps {
  rowCivilization: string;
  colCivilizations: string[];
  rowLetter: string;
}

const Row: React.FC<RowProps> = ({ rowCivilization, colCivilizations,rowLetter }) => {
  const isLongCiv = (civ: string) => {
    return civ.length > 7;
  }
  
  const getClasses = (civ: string) => {
    return isLongCiv(civ) ? 'cell civ long' : 'cell civ';
  }

  return (
    <div className="row">
      <div className={getClasses(rowCivilization)}>{rowCivilization}</div>
      {colCivilizations.map((colCivilization, colIndex) => (
        <Cell key={colIndex} x={rowLetter} y={(colIndex + 1).toString()} />
      ))}
    </div>
  );
}

export default Row;